import React, { useCallback, useState } from "react";
import GalleryLightBox from "../../../components/GalleryLightBox";
import { MessageProps } from "../../../typings/messages";

export interface MessageTextProps {
    message: MessageProps;
    position: string;
    renderTicks: any;
    imageMessages: any
}
const MessageImage = ({ imageMessages, message, position, renderTicks }: MessageTextProps) => {
    const [LightBoxIsOpen, setLightBoxIsOpen] = useState(false);
    const [messagesIds, setMessagesIds] = useState(imageMessages.map((item: any) => item.id));
    const [messageIndex, setMessageIndex] = useState(messagesIds.indexOf(message.messageId));

    const handleImageClick = () => {
        setLightBoxIsOpen(true);
        setMessageIndex(messagesIds.indexOf(message.messageId));
    }

    return (
        <>
            <div className={position === "left" ? "talk_group flip" : "talk_group w-clearfix"}>
                <div className={position === "left" ? "buble flip" : "buble"}>
                    <div className="buble_pict">
                        {
                            message.image ?
                                <img src={message.image} alt="" onClick={handleImageClick} />
                                : null
                        }
                    </div>
                </div>
                {renderTicks()}
            </div>

            {LightBoxIsOpen && (
                <GalleryLightBox
                    imagePage={messageIndex}
                    isOpen={LightBoxIsOpen}
                    images={imageMessages}
                    mediaLength={imageMessages?.length}
                    onClose={() => setLightBoxIsOpen(false)}
                />
            )}
        </>
    )
}


export default MessageImage;